import React from 'react';

const ReceiptScanningSection = () => {
  return (
    <section className="border-t border-slate-100 bg-slate-50/90 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2 lg:gap-16">
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-cyan-700">Job cost reality</p>
            <h2 className="mt-3 text-3xl font-bold tracking-tight text-slate-900 md:text-4xl">
              Receipts tied to real job cost
            </h2>
            <p className="mt-4 text-lg leading-relaxed text-slate-600">
              Upload receipts and attach spend to projects. See whether the job paid after materials, labour, and overhead—not just what you invoiced.
            </p>
            <ul className="mt-8 space-y-3 text-slate-700">
              <li className="flex gap-3">
                <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-cyan-500" />
                <span>Attach spend to projects so margin isn’t a post-mortem.</span>
              </li>
              <li className="flex gap-3">
                <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-cyan-500" />
                <span>Keep a paper trail without drowning in folders.</span>
              </li>
              <li className="flex gap-3">
                <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-cyan-500" />
                <span>Understand true job cost—not just what you invoiced.</span>
              </li>
            </ul>
          </div>
          <div className="rounded-3xl border border-slate-200/90 bg-gradient-to-br from-slate-50 to-cyan-50/50 p-8 shadow-inner md:p-10">
            <p className="text-sm font-semibold uppercase tracking-wide text-slate-500">What you get</p>
            <p className="mt-4 text-xl font-semibold text-slate-900">Quote with confidence. Reconcile with reality.</p>
            <p className="mt-3 text-sm leading-relaxed text-slate-600">
              DevelloTech is built so the quote you send and the costs you run later live in the same story—especially on Pro, where projects, expenses, and visibility come together.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ReceiptScanningSection;
